import { render, staticRenderFns } from "./CustomerPricesDetail.vue?vue&type=template&id=73b1c0b4"
import script from "./CustomerPricesDetail.vue?vue&type=script&lang=js"
export * from "./CustomerPricesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports